import api from './api';

// Servicios para Categorías
export const getCategorias = async () => {
  try {
    const response = await api.get('/api/categories');
    console.log('Categorias obtenidas:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error al obtener categorías:', error);
    throw error;
  }
};

export const getCategoriasConDetalles = async () => {
  try {
    const response = await api.get('/api/categories/with-details');
    return response.data;
  } catch (error) {
    console.error('Error al obtener categorías con detalles:', error);
    throw error;
  }
};

export const getCategoriaById = async (id) => {
  try {
    const response = await api.get(`/api/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener categoría con ID ${id}:`, error);
    throw error;
  }
};

export const getCategoriaConDetallesById = async (id) => {
  try {
    const response = await api.get(`/api/categories/${id}/with-details`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener categoría con detalles con ID ${id}:`, error);
    throw error;
  }
};

export const crearCategoria = async (categoria) => {
  try {
    const response = await api.post('/api/categories', categoria);
    return response.data;
  } catch (error) {
    console.error('Error al crear categoría:', error);
    throw error;
  }
};

export const actualizarCategoria = async (id, categoria) => {
  try {
    const response = await api.put(`/api/categories/${id}`, categoria);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar categoría con ID ${id}:`, error);
    throw error;
  }
};

export const eliminarCategoria = async (id) => {
  try {
    const response = await api.delete(`/api/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar categoría con ID ${id}:`, error);
    throw error;
  }
};

// Servicios para Subcategorías
export const getSubcategorias = async () => {
  try {
    const response = await api.get('/api/subcategories');
    return response.data;
  } catch (error) {
    console.error('Error al obtener subcategorías:', error);
    throw error;
  }
};

export const getSubcategoriasConDetalles = async () => {
  try {
    const response = await api.get('/api/subcategories/with-details');
    return response.data;
  } catch (error) {
    console.error('Error al obtener subcategorías con detalles:', error);
    throw error;
  }
};

export const getSubcategoriasByCategoria = async (categoriaId) => {
  try {
    const response = await api.get(`/api/subcategories/by-category/${categoriaId}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener subcategorías por categoría con ID ${categoriaId}:`, error);
    throw error;
  }
};

export const getSubcategoriaById = async (id) => {
  try {
    const response = await api.get(`/api/subcategories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener subcategoría con ID ${id}:`, error);
    throw error;
  }
};

export const crearSubcategoria = async (subcategoria) => {
  try {
    const response = await api.post('/api/subcategories', subcategoria);
    return response.data;
  } catch (error) {
    console.error('Error al crear subcategoría:', error);
    throw error;
  }
};

export const actualizarSubcategoria = async (id, subcategoria) => {
  try {
    const response = await api.put(`/api/subcategories/${id}`, subcategoria);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar subcategoría con ID ${id}:`, error);
    throw error;
  }
};

export const eliminarSubcategoria = async (id) => {
  try {
    const response = await api.delete(`/api/subcategories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar subcategoría con ID ${id}:`, error);
    throw error;
  }
};

// Servicios para Definiciones de Servicios
export const getServicios = async () => {
  try {
    const response = await api.get('/api/servicedefinitions');
    return response.data;
  } catch (error) {
    console.error('Error al obtener servicios:', error);
    throw error;
  }
};

export const getServiciosBySubcategoria = async (subcategoriaId) => {
  try {
    const response = await api.get(`/api/servicedefinitions/by-subcategory/${subcategoriaId}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener servicios por subcategoría con ID ${subcategoriaId}:`, error);
    throw error;
  }
};

export const getServicioById = async (id) => {
  try {
    const response = await api.get(`/api/servicedefinitions/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener servicio con ID ${id}:`, error);
    throw error;
  }
};

export const crearServicio = async (servicio) => {
  try {
    const response = await api.post('/api/servicedefinitions', servicio);
    return response.data;
  } catch (error) {
    console.error('Error al crear servicio:', error);
    throw error;
  }
};

export const actualizarServicio = async (id, servicio) => {
  try {
    const response = await api.put(`/api/servicedefinitions/${id}`, servicio);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar servicio con ID ${id}:`, error);
    throw error;
  }
};

export const eliminarServicio = async (id) => {
  try {
    const response = await api.delete(`/api/servicedefinitions/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar servicio con ID ${id}:`, error);
    throw error;
  }
};

// Servicio para actualizar el precio por lead de una subcategoría
export const actualizarPrecioPorLead = async (subcategoriaId, precio) => {
  try {
    console.log(`Actualizando precio por lead para subcategoría ${subcategoriaId} a ${precio}`);
    const response = await api.put(`/api/subcategories/${subcategoriaId}/lead-price`, { leadPrice: precio });
    console.log('Respuesta del servidor:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar precio por lead para subcategoría con ID ${subcategoriaId}:`, error);
    throw error;
  }
};

// Servicio para obtener los precios por lead de todas las subcategorías
export const getLeadPrices = async () => {
  try {
    const response = await api.get('/api/subcategories/lead-prices');
    console.log('Precios por lead obtenidos:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error al obtener precios por lead:', error);
    throw error;
  }
};

const categoriaService = {
  getCategorias,
  getCategoriasConDetalles,
  getCategoriaById,
  getCategoriaConDetallesById,
  crearCategoria,
  actualizarCategoria,
  eliminarCategoria,
  getSubcategorias,
  getSubcategoriasConDetalles,
  getSubcategoriasByCategoria,
  getSubcategoriaById,
  crearSubcategoria,
  actualizarSubcategoria,
  eliminarSubcategoria,
  getServicios,
  getServiciosBySubcategoria,
  getServicioById,
  crearServicio,
  actualizarServicio,
  eliminarServicio,
  actualizarPrecioPorLead,
  getLeadPrices
};

export default categoriaService;
